export interface InventoryState {
    inventoryList: InventoryList[],
    inventoryDetails: InventoryDetail,
    inventoryProductDetails: any,
    badge: BadgeData[],
    skusList: SkusList[],
    inventoriesToExecute: InventoryList[],
    configsToExecuteInventory?: ConfigsToExecuteInventory,
    dataToExecuteInventory: DataToExecuteInventory,
    dataPosition: DataPosition,
    isThirdCount: boolean,
    goToPosition: boolean,
    goToTableInventories: boolean,
    clickExecuteInventory: boolean,
    needGetPosition: boolean,
}

export interface SkusList {
    codProduct: string,
    descProduct: string,
    idModel: number,
    valid: boolean
}

export interface BadgeData {
    userBadge: string,
    userName: string
}

export enum GenericApiErrors {
    Failed,
}

export interface GetInventoryPayload {
    fulfillmentCenterId: string,
    initialDate: string,
    finalDate: string,
}

export interface IdPayload {
    id: number,
}

export interface ApproveDisapprovePayload {
    idProductInventory: number,
    approvalStatus: boolean,
}

export interface ResetAdjustmentApprovalPayload {
    idProductInventory: number
}

export interface InventoryList {
    id: number,
    inventoryName: string,
    createdAt: Date,
    currentStatus: InventoryStatus,
    percentageExecution: number,
    skusQty: number,
    percentageAccuracy: number,
    countType: string,
}

export interface SetInventoryList {
    inventoryList: InventoryState['inventoryList'];
}

export interface SetInventoriesToExecute {
    inventoriesToExecute: InventoryState['inventoriesToExecute'];
}

export interface SetDataPosition {
    dataPosition: InventoryState['dataPosition'];
}

export interface SetInventoryStatus {
    id: number,
    currentStatus: InventoryStatus,
}

export interface SetSkusList {
    skusList: InventoryState['skusList'];
}

export interface SetInventoryDetails {
    inventoryDetails: InventoryState['inventoryDetails'];
}

export interface CreateInventoryPayload {
    name: string,
    type: TypesInventoryEnum
    skus: string[]
    badges: string[]
    fulfillmentCenterId: string
    lost_locations: boolean
}

export interface ValidateSkusPayload {
    skus: string[]
}

export interface IncrementDecrementPayload {
    products: IncrementDecrementProduct[]
    id: number
    setProductsCodeNotFound: (productsCodeNotFound: string[]) => void
    setInputValue: (inputValue: string) => void
    setOpen: (open: boolean) => void
}

export interface IncrementDecrementProduct {
    productCode: string,
    quantity: number,
}

export enum TypesInventoryEnum {
    SIMPLE='Simples',
    VALIDATE='Validade'
}

export interface ValidateBadgeExecuteInventoryPayload{
    badge: string,
    id: number,
    setError: (error: string) => void,
}

export interface ValidateBadgePayload{
    badge: string,
    setError: (error: string) => void,
    onSuccess: () => void
}

export interface GetPositionPayload{
    floor: number,
    addressesTypes: number[],
    badge: string,
    id: number,
    isThirdCount: boolean,
    afterFinishPosition?: boolean,
}

export interface DeleteBadgePayload{
    badge?: string,
    badgeToDelete: string,
}

export interface SetBadge {
    badge: InventoryState['badge'];
}

export enum ItemStatus {
    WAITING_START='Aguardando início',
    EXECUTING_COUNT='Executando contagem',
    ADJUSTMENT_ANALYSIS='Em análise de ajustes',
    FINISHED='Finalizado',
}

export enum InventoryStatus {
    CREATED='Criado',
    IN_PROGRESS='Em execução',
    FINISHED='Finalizado',
    CANCELED='Cancelado',
}

export interface ProductInventoryDetail {
    finalCount: number,
    firstCountQuantity: number,
    firstCountDamage: number,
    secondCountQuantity: number,
    secondCountDamage: number,
    thirdCountQuantity: number,
    thirdCountDamage: number,
    id: number,
    increment: number,
    productCode: string,
    productDescription: string,
    status: ItemStatus,
    finalAdjustment: number,
    ruleOne: boolean,
    ruleTwo: boolean,
    ruleThree: boolean,
    adjustmentApproval: boolean | null,
}

export interface InventoryDetail {
    id: number,
    countType: string,
    createdAt: Date,
    creatorUserName: string,
    inventoryName: string,
    products: ProductInventoryDetail[],
    inventoryStatus: InventoryStatus,
}

export interface ResponseIncrement {
    notFoundProducts: string[],
    inventoryDetails: InventoryDetail,
}

export interface InventoriesToExecutePayload {
    fulfillmentCenterId: number
}

export interface DataPosition {
    idPosition: number,
    positionAddress: string,
    operatorName: string,
    productDescription: string,
    expirationDateBatches: ExpirationDateBatches[],
    countType: string,
    enabledThirdCount: boolean,
    openCount: boolean,
    tryAgain: boolean,
    currentTotal: number,
    currentDamage: number,
    afterFinishPosition?: boolean,
}

export interface ExpirationDateBatches {
    id: number,
    idInventoryProductPosition: number,
    countNumber: number,
    expirationDate: string,
    quantity: number,
    damage: number,
}

export interface IdBadgePayload {
    idPosition: number,
    badge: string,
}

export interface UnlinkOperatorPayload {
    idPosition: number,
    badge: string,
    badgeSupervisor?: string,
    setError: (error: string) => void,
}

export interface SavePositionPayload {
    idPosition: number,
    quantity: number,
    setHasPosition: (hasPosition: boolean) => void,
    badge: string,
    expirationDate?: string,
}

export interface SavePositionDamagePayload {
    idPosition: number,
    quantityDamage: number,
    badge: string,
    expirationDateDamage?: string,
}

export interface CancelQuantityItemPayload {
    idPosition: number,
    expirationDate?: string,
    badge: string,
}

export interface SetAdjustmentApproval {
    idProductInventory: number,
    approvalStatus: boolean | null,
}

export interface GetInventoryProductDetailsPayload {
    inventoryId: number,
    productCode: string,
}

export interface InventoryProductPosition {
  endereco_generated: string;
  first_count_damage: number;
  first_count_finished_at: string;
  first_count_operator_name: string;
  first_count_quantity: number;
  second_count_damage: number;
  second_count_finished_at: string;
  second_count_operator_name: string;
  second_count_quantity: number;
  third_count_damage: number;
  third_count_finished_at: string | null;
  third_count_operator_name: string | null;
  third_count_quantity: number | null;
}

export interface InventoryProductDetails {
  delay_adjustment: number;
  desc_produto: string;
  increment_value: number;
  initial_stock: number;
  inventory_name: string;
  positions: InventoryProductPosition[];
  total_adjustment: number;
  total_counted: number;
}

export interface SetDataToExecuteInventory {
    badge?: string,
    floor?: number,
    addressesTypes?: number[],
}

interface DataToExecuteInventory {
    floor: number
    addressesTypes: number[]
    badge: string
}

interface InventoryFloor {
    id: number,
    description: string,
}

interface InventoryAddressType {
    id: number,
    description: string,
}

export interface ConfigsToExecuteInventory {
    floors: InventoryFloor[],
    addressesTypes: InventoryAddressType[],
}
